module.exports = __webpack_public_path__ + "img/success_icon.c1f644bc.svg";